import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';

// Maps the 3-letter character code (matching GGST's internal /Game/Chara/{CharaID}/
// asset paths) to the official Arc System Works archive portrait URL. There's no
// derivable pattern — folder is per-release year/month and slugs are opaque
// WordPress hashes — so this table is exhaustively transcribed and verified.
// All URLs return HTTP 200 image/jpeg via CloudFront. Update when DLC drops.
const PORTRAIT_BASE = 'https://www.guiltygear.com/ggst/en/wordpress/wp-content/uploads/';
const PORTRAIT_PATHS: Record<string, string> = {
  SOL: '2020/09/archive.jpg',
  KYK: '2020/09/archive_kyk.jpg',
  MAY: '2020/09/archive_may-1.jpg',
  AXL: '2020/09/archive_axl.jpg',
  CHP: '2020/09/archive_chp.jpg',
  POT: '2020/09/archive_pot.jpg',
  FAU: '2020/09/archive_fau.jpg',
  MLL: '2020/09/archive_mll.jpg',
  ZAT: '2020/09/archive_zat.jpg',
  RAM: '2020/09/archive_ram-1.jpg',
  LEO: '2020/09/archive_leo.jpg',
  NAG: '2020/09/archive_nag.jpg',
  GIO: '2020/09/archive_gio.jpg',
  ANJ: '2021/03/anji-306x305.jpg',
  INO: '2021/03/rxx82us-1-306x305.jpg',
  GLD: '2021/07/gol-306x305.jpg',
  JKO: '2021/08/jko.jpg',
  COS: '2021/11/82nCeh3s.jpg',
  BKN: '2022/01/94gvos0f.jpg',
  TST: '2022/03/icon-1ubduiak.jpg',
  BGT: '2022/08/38nd9nd2jd73.jpg',
  SIN: '2022/11/n5idg73diw3.jpg',
  BED: '2023/03/5fve3hdwci.jpg',
  ASK: '2023/05/xnNj771Auw.jpg',
  JHN: '2023/08/archive_4ny9b-6nvi.jpg',
  ELP: '2023/12/4nf89dcoo3.jpg',
  ABA: '2024/03/3uf9vnso76.jpg',
  SLY: '2024/04/4tg8hdo2.jpg',
  DZY: '2018/10/archive-ny040fsi2.jpg',
  VEN: '2025/03/adhfjha.jpg',
  UNI: '2025/05/khfauiy.jpg',
  LUC: '2025/08/qokdhj.jpg',
  JAM: '2026/04/archive_jam.jpg'
};
export const ggstPortraitUrl = (code?: string): string | null => {
  if (!code) return null;
  const path = PORTRAIT_PATHS[code.toUpperCase()];
  return path ? `${PORTRAIT_BASE}${path}` : null;
};
export const GGSTPortrait = t0 => {
  const $ = _c(24);
  const {
    character,
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 200 : t1;
  const className = t2 === undefined ? "" : t2;
  let t3;
  if ($[0] !== character) {
    t3 = ggstPortraitUrl(character);
    $[0] = character;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const url = t3;
  if (character == "unknown") {
    const t4 = `bg-gray-700 flex items-center justify-center ${className}`;
    let t5;
    if ($[2] !== size) {
      t5 = {
        width: size,
        height: size
      };
      $[2] = size;
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <span className="text-gray-400 text-sm">{"?"}</span>;
      $[4] = t6;
    } else {
      t6 = $[4];
    }
    let t7;
    if ($[5] !== t4 || $[6] !== t5) {
      t7 = <div className={t4} style={t5}>{t6}</div>;
      $[5] = t4;
      $[6] = t5;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    return t7;
  }
  if (!url) {
    const t4 = `bg-gray-700 flex items-center justify-center ${className}`;
    let t5;
    if ($[8] !== size) {
      t5 = {
        width: size,
        height: size
      };
      $[8] = size;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    const t6 = character ?? "?";
    let t7;
    if ($[10] !== t6) {
      t7 = <span className="text-gray-400 text-sm">{t6}</span>;
      $[10] = t6;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    let t8;
    if ($[12] !== t4 || $[13] !== t5 || $[14] !== t7) {
      t8 = <div className={t4} style={t5}>{t7}</div>;
      $[12] = t4;
      $[13] = t5;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  const t4 = `${character} portrait`;
  let t5;
  if ($[16] !== size) {
    t5 = {
      width: size,
      height: size,
      objectFit: "cover"
    };
    $[16] = size;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== className || $[19] !== size || $[20] !== t4 || $[21] !== t5 || $[22] !== url) {
    t6 = <Image src={url} alt={t4} className={className} width={size} height={size} style={t5} unoptimized={true} />;
    $[18] = className;
    $[19] = size;
    $[20] = t4;
    $[21] = t5;
    $[22] = url;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
};